import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  price: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },
  priceValue: {
    color: theme.colorPalette.white_10,
    lineHeight: 1.5
  },
  priceNote: {
    color: theme.colorPalette.beige_10_op_75,
    textAlign: 'center',
    textTransform: 'uppercase'
  },
  disabled: {
    color: theme.colorPalette.beige_10_op_13
  }
});

export default makeStyles(styles);
